module.exports = __webpack_public_path__ + "static/img/score-pc-4.84b6acfc.png";